$(() => {
	// let gallery_slider = $('.js-gallery-container');
	// gallery_slider.slick({
		// // prevArrow: main_slider.closest('.js-main-slider').find('.controls .prev'),
		// // nextArrow: main_slider.closest('.js-main-slider').find('.controls .next'),
		// dots: false,
		// autoplay: true,
		// autoplaySpeed: 2000,
	// });
    // слайдер галерейки
    $(".js-gallery-slider").slick({
        rows: 0,
        slidesToShow: 2,
        lazyLoad: "ondemand",
        nextArrow:
            '<button class="slider__btn--next slick-arrow slider__btn gallery-slider__btn" aria-label="next" type="button"><svg id="slider-next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 407.1 407.1"> <path d="M203.5,407.1C91.5,407.1,0,315.6,0,203.5C0,91.5,91.5,0,203.5,0c112,0,203.5,91.5,203.5,203.5 C407.1,315.6,315.6,407.1,203.5,407.1L203.5,407.1z M203.5,24.8c-98.3,0-177.9,79.5-177.9,177.9s79.5,177.9,177.9,177.9 c98.3,0,177.9-79.5,177.9-177.9S301.9,24.8,203.5,24.8L203.5,24.8z M203.5,24.8"></path> <path d="M165,292.5c-3.4,0-6.8-0.9-9.4-3.4c-5.1-5.1-5.1-12.8,0-18l67.6-67.6L155.6,136c-5.1-5.1-5.1-12.8,0-18 c5.1-5.1,12.8-5.1,18,0l76.1,76.1c2.6,2.6,3.4,6,3.4,9.4c0,3.4-1.7,6.8-3.4,9.4l-75.3,75.3C171.9,290.8,168.5,292.5,165,292.5 L165,292.5z M165,292.5"></path> </svg></button>',
        prevArrow:
            '<button class="slider__btn--prev slick-arrow slider__btn gallery-slider__btn" aria-label="prev" type="button"><svg id="slider-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 407.1 407.1"> <path d="M203.5,0c112,0,203.5,91.5,203.5,203.5c0,112-91.5,203.5-203.5,203.5C91.5,407.1,0,315.6,0,203.5 C0,91.5,91.5,0,203.5,0L203.5,0z M203.5,382.3c98.3,0,177.9-79.5,177.9-177.9S301.9,26.5,203.5,26.5 c-98.3,0-177.9,79.5-177.9,177.9S105.2,382.3,203.5,382.3L203.5,382.3z M203.5,382.3"></path> <path d="M242,114.6c3.4,0,6.8,0.9,9.4,3.4c5.1,5.1,5.1,12.8,0,18l-67.6,67.6l67.6,67.6c5.1,5.1,5.1,12.8,0,18 c-5.1,5.1-12.8,5.1-18,0l-76.1-76.1c-2.6-2.6-3.4-6-3.4-9.4c0-3.4,1.7-6.8,3.4-9.4l75.3-75.3C235.2,116.3,238.6,114.6,242,114.6 L242,114.6z M242,114.6"></path> </svg></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $("body").on("click", ".js-gallery-slider-btn", function() {
        $(".js-gallery-slider").slick("refresh");
    });

    window.albums_keys = [];

    let opened_album_id = null;
    let thumb_state = true;
    function showAlbum(id) {
        if (typeof albums[id] === "undefined") {
            return;
        }

		let album = albums[id];
		// console.log(albums);
        let informer = $("body").find("#modal_album");
        if (informer.length < 1) {
            informer = $('<div class="modal_album" id="modal_album"></div>');
            informer.appendTo($("body"));
        }

        let data = [];
        let url = location.protocol + "//" + location.host;
        let has_big = true;
        let has_very_big = false;

        url += "/album/" + album.u;

        try {
            if (window.innerWidth < 450) {
                has_big = false;
            }
            if (window.innerWidth > 1360) {
                has_very_big = true;
            }
        } catch (e) {
            console.log(e);
        }

        for (let i in album.photos) {
            let a = album.photos[i];
            let item = {};
            item.src = has_big ? a.s : a.m;
            if (has_very_big) {
                item.src = a.b;
            }
            item.type = "image";
            item.opts = {};
            item.opts.thumb = a.t;
            item.opts.infobar = "123";

            item.opts.caption =
                `<div class="fancybox-caption-info flex-container align-center">
					<div class="col--6 col--md--auto text--center">
						<button class="js-prev-album fancybox-caption-info__btn left d-inline-flex link-hovered align-center" title="Предыдущий альбом">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" class="c--white icon"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg>
							<span><em class="d-none d--md-inline">Предыдущий</em><em class="d--md-none">Пред.</em> альбом</span>
						</button>
					</div>
					<div class="fancybox-caption-info-content col--12 col--md f--em--large">` +
                album.t +
                `</div>
					<div class="col--6 col--md--auto text--center">
						<button class="js-next-album fancybox-caption-info__btn right d-inline-flex link-hovered align-center" title="Следующий альбом">
							<span><em class="d-none d--md-inline">Следующий</em><em class="d--md-none">След.</em> альбом</span>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" class="c--white icon"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg>
						</button>
					</div>
				</div>`;
            data.push(item);
        }

		$.fancybox.open(data, {
			loop: true,
			title: "content",
			helpers: {
				caption: "123"
			},
			thumbs: {
				autoStart: thumb_state, // Display thumbnails on opening
				axis: "x" // Vertical (y) or horizontal (x) scrolling
			},
			beforeShow: function() {
				opened_album_id = id;
				try {
					let root = location.protocol + "//" + location.host;
					let url = "/gallery/" + album.u;
					let hisObj = {
						url: location.href
					};
					window.history.pushState(hisObj, "", root + url);
				} catch (e) {
					console.log(e);
				}
			},
			beforeClose: function() {
				opened_album_id = null;
				try {
					let root = location.protocol + "//" + location.host;
					let url = "/";
					let hisObj = {
						url: location.href
					};
					window.history.pushState(hisObj, "", root + url);
				} catch (e) {
					console.log(e);
				}
			}
		});
	}

    function showAlbumFromUrl() {
        try {
            if (typeof albums !== "undefined") {
                for (let i in albums) {
                    albums_keys.push(i);
                }
            }
            let id = $("body").attr("current-album");
            if (typeof id !== "undefined") {
                showAlbum(id);
            }
        } catch (e) {
            console.log(e);
        }
    }

    if (window.innerWidth < 450) {
        thumb_state = false;
    }
    showAlbumFromUrl();
    $("body")
        .on("click", ".fancybox-button--thumbs", function() {
            thumb_state = !thumb_state;
        })
        .on("click", ".js-close-album", function() {
            $.fancybox.close();
        })
        .on("click", ".js-next-album", function() {
            try {
				let current_tab = albums[opened_album_id].c;
				console.log(current_tab);
                let loop_id = null;
                let is_next = false;
                let next_id = null;
                for (let i = albums_keys.length - 1; i > -1; i--) {
                    let id = albums_keys[i];
					
					if(albums[id].c != current_tab) {
						continue;
					}
                    if (is_next) {
                        next_id = id;
                        break;
                    }
                    if (loop_id === null) {
                        loop_id = id;
                    }
                    if (id == opened_album_id) {
                        is_next = true;
                    }
                }
                if (next_id === null && loop_id !== null) {
                    next_id = loop_id;
                }
                if (next_id !== null) {
                    // $('body').find('.fancybox-button--close').click();
                    $.fancybox.close();
                    showAlbum(next_id);
                }
            } catch (e) {
                console.log(e);
            }
            return false;
        })
        .on("click", ".js-prev-album", function() {
            try {
                let current_tab = albums[opened_album_id].c;
				let loop_id = null;
                let is_next = false;
                let next_id = null;
                for (let i = 0; i < albums_keys.length; i++) {
                    let id = albums_keys[i];
					
					if(albums[id].c != current_tab) {
						continue;
					}
                    if (is_next) {
                        next_id = id;
                        break;
                    }
                    if (loop_id === null) {
                        loop_id = id;
                    }
                    if (id == opened_album_id) {
                        is_next = true;
                    }
                }
                if (next_id === null && loop_id !== null) {
                    next_id = loop_id;
                }
                if (next_id !== null) {
                    // $('body').find('.fancybox-button--close').click();
                    $.fancybox.close();
                    showAlbum(next_id);
                }
            } catch (e) {
                console.log(e);
            }
            return false;
        })
        .on("click", ".js-has-album", function() {
            let id = $(this).attr("data-id");
            showAlbum(id);
            return false;
        });
});
